/**
 * @module util
 * @alias 通用工具
 */
import Vue from 'vue'
import proj4 from 'proj4'

// 引入moment
import moment from 'moment'
import 'moment/locale/zh-cn'
moment.locale('zh-cn')
Vue.prototype.$moment = moment

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  let event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * 过滤对象中为空的属性
 * @param obj
 * @returns {*}
 */
export function filterObj(obj) {
  if (!(typeof obj === 'object')) {
    return
  }

  for (let key in obj) {
    if (obj.hasOwnProperty(key) &&
      (obj[key] == null || obj[key] === undefined || obj[key] === '')) {
      delete obj[key]
    }
  }
  return obj
}

/**
 * 时间格式化
 * @param value
 * @param fmt
 * @returns {*}
 */
export function formatDate(value, fmt) {
  let regPos = /^\d+(\.\d+)?$/
  if (regPos.test(value)) {
    // 如果是数字
    let getDate = new Date(value)
    let o = {
      'M+': getDate.getMonth() + 1,
      'd+': getDate.getDate(),
      'h+': getDate.getHours(),
      'm+': getDate.getMinutes(),
      's+': getDate.getSeconds(),
      'q+': Math.floor((getDate.getMonth() + 3) / 3),
      'S': getDate.getMilliseconds()
    }
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    for (let k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
      }
    }
    return fmt
  } else {
    // TODO
    value = value.trim()
    return value.substr(0, fmt.length)
  }
}

/**
 * 时间换算  把年月日时分秒转换成几分钟前 几小时前....
 * @param {string} preTime 要转换的时间
 * @return 转换后的
 */
export function timeTransfer(preTime){
  var minute = 1000 * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var week = day * 7;
  var month = day * 30;
  var year = month * 12
  var time1 = new Date().getTime();//当前的时间戳
  var time2 = Date.parse(preTime.replace(/-/g, '/'));//指定时间的时间戳
  var time = time1 - time2;
  var result = null;
  if (time < 0) {
    alert("设置的时间不能早于当前时间！");
  } else if(time / year >= 1){
    result = parseInt(time / year) + "年前";
  } else if (time / month >= 1) {
    result = parseInt(time / month) + "个月前";
  } else if (time / week >= 1) {
    result = parseInt(time / week) + "周前";
  } else if (time / day >= 1) {
    result = parseInt(time / day) + "天前";
  } else if (time / hour >= 1) {
    result = parseInt(time / hour) + "小时前";
  } else if (time / minute >= 1) {
    result = parseInt(time / minute) + "分钟前";
  } else {
    result = "刚刚";
  }
  return result;
}

/**
 * 深度克隆对象、数组
 * @param obj 被克隆的对象
 * @return 克隆后的对象
 */
export function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj))
}
/**
 * 接口传参需要，省传前两位，市传前四位，县和乡镇传全部
 * @param xzqdm 
 * @return {string} 截取后的行政区代码
 */
export function handleXzqdm(xzqdm) {
  if(xzqdm){
    xzqdm = typeof(xzqdm) == 'string' ? xzqdm : xzqdm.toString()
    if(xzqdm.substring(2) == '0000'){
      xzqdm = xzqdm.substring(0,2)
    }else if(xzqdm.substring(4) == '00'){
      xzqdm = xzqdm.substring(0,4)
    }
  }
  return xzqdm
}

/**
 * 数字千分位逗号分隔
 * @param {*} number 分隔前的值
 * @param {number|string|null} decimal 要保留几位小数（如果传字符串 'false'，说明后端返回的数据已经处理过小数位了，这边不用处理，只需要加千位分隔符）
 * @param {boolean|null} keepDecimal 当Number(number) == 0 时：如果该属性是true，则保留对应的小数，否则不保留小数
 * @return {string} 分隔后的值
 */
export function thousands(number,decimal,keepDecimal) {
  if(!isNaN(Number(number))){
    // 可能是 234  '234'  null '' 0
    number = Number(number)
    if(decimal == 'false'){
      var str = number.toString();
      var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg,"$1,");
    }else{
      decimal = decimal || decimal === 0 ? decimal : 4
      if(number == 0){
        return keepDecimal ? number.toFixed(decimal) : number
      }else{
        number = number.toFixed(decimal)
        var str = number.toString();
        var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
        return str.replace(reg,"$1,");
      }
    }
  }else{
    // 可能是 '——'
    return number
  }
}
/**
 * 数值的单位换算（不适合echarts的单位换算）
 * @param number 换算前的数值
 * @param unit 换算前的单位  目前支持的单位：万元、吨、公顷、元/㎡
 * @param decimal 换算后保留几位小数，不传默认4位
 * @param ifFillZero 换算后保留几位小数，位数不足的是否要补0，不传默认补，传'false'不补
 * @param toString 换算后的数值是否加分隔符变成字符串，不传默认变，传'false'不变
 * @return 换算后的数值和单位
 */
export function valueConversion(number,unit,decimal,ifFillZero,toString) {
  // console.log('number',number);
  number = number ? Number(number) : 0
  unit = unit ? unit : '万元'
  decimal = decimal || decimal === 0 ? decimal : 4
  ifFillZero = ifFillZero === 'false' ? false : true
  // 判断传来的单位里有没有万字
  var hasWan = unit.indexOf('万')
  if(number == 0){
    return { num:0, unit:unit }
  }else{
    // 先换算，再保留小数，再转字符串加分隔符
    if(hasWan > -1){
      // 单位是 万元
      if(number < 10000){
        number = number
        unit = '万元'
      }else if(number >= 10000 && number < 100000000){
        number = number / 10000
        unit = '亿元'
      }else if(number >= 100000000){
        number = number / 100000000
        unit = '万亿元'
      }
    }else{
      // 单位不带万字
      if(number < 10000){
        number = number
        unit = unit
      }else if(number >= 10000 && number < 100000000){
        number = number / 10000
        unit = `万${unit}`
      }else if(number >= 100000000){
        number = number / 100000000
        unit = `亿${unit}`
      }
    }
    number = ifFillZero ? number.toFixed(decimal) : parseFloat(number.toFixed(decimal))
    if(toString !== 'false'){
      var str = number.toString();
      var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      number = str.replace(reg,"$1,")
    }
    return { num:number, unit:unit };
  }
}

/**
 * 单位换算（用于echarts)
 * @param info 分隔前的数字  包含：maxNum 最大值； minNum 最小值（不为0）； unit 原始单位； decimal 保留几位小数
 * @return {string} 换算后的单位
 */
export function changeUnit(info){
  let {maxNum,minNum,unit,decimal} = info
  if(maxNum == minNum){
    return valueConversion(maxNum,unit,decimal).unit
  }
  minNum = Number(minNum)
  // 获取最小值的第一位数
  let minNumFirst = minNum.toString().substring(0,1)
  // 此方法的目的是确保最小值转换后不会为0
  // 比如 要求保留4位小数，最小值 minNum 是25，单位万元；它转换后的值 limMinNum 不能小于0.0002（可以是 0.0002/0.0025/0.0250/0.2500/2.5000/25.0000）；计算倍率，再通过倍率算得最终转换后的单位
  // 计算倍率的方法(即 minNum 和 limMinNum 相差的倍数)
  let handleMultiple = num => {
    let power = Number( Math.pow(10, -decimal).toFixed(decimal) )  // 由于浮点数精度问题，出现类似10的-4方等于0.00009999999999999999，所以要保留小数，并转换成数值类型
    return Number((Number(num) * power).toFixed(decimal))  // 同样 乘法也会出现精度问题，需要保留小数并转化为数值
  }
  // 目前支持 吨 万元 公顷 后续有需求再加
  if(handleMultiple(minNumFirst) == 0){
    unit = unit
  }else{
    let multiple = minNum / handleMultiple(minNumFirst);
    console.log('11111',handleMultiple(minNumFirst),multiple,maxNum);
    if(multiple < 10000 || (multiple >= 10000 && multiple < 100000000 && maxNum <= 10000)){
        // 相差在1万倍以内 或者 相差在1万-1亿倍且最大值不到1万  不需要转换
      unit = unit
    }else if((multiple >= 10000 && multiple < 100000000 && maxNum > 10000 && maxNum <= 100000000)
      || (multiple >= 100000000 && maxNum <= 100000000)){
      // 相差在1万-1亿倍且最大值在1万-1亿之间 或者 相差在1亿倍以上且最大值不到1亿   转换才有意义
      if(unit == '吨' || unit == '公顷'){
        unit = '万' + unit
      }else if(unit == '万元'){
        unit = '亿元'
      }
    }else if(maxNum > 100000000 && multiple >= 100000000){
      // 相差1亿倍以上  且最大值要大于1亿 转换才有意义
      if(unit == '吨' || unit == '公顷'){
        unit = '亿' + unit
      }else if(unit == '万元'){
        unit = '万亿元'
      }
    }
  }
  return unit
}

/**
 * 把数值按指定单位换算
 * @param number 换算前的数值
 * @param unit 要换算成什么单位
 * @param ifFillZero 换算后保留几位小数，位数不足的是否要补0，传'false'就不补，不传默认要补
 * @param toString 换算后的数值是否加分隔符变成字符串，传'false'就不变，不传默认要变
 * @return 换算后的数值
 */
export function valueConversionByUnit(number,unit,decimal,ifFillZero,toString) {
  number = number ? Number(number) : 0
  decimal = decimal || decimal === 0 ? decimal : 4
  ifFillZero = ifFillZero === 'false' ? false : true
  if(number == 0){
    return { num:0,unit:unit }
  }else{
    if(unit == '万吨' || unit == '万公顷' || unit == '亿元' || unit == '万元/平方米'){
      number = number / 10000
    }else if(unit == '亿吨' || unit == '万亿元' || unit == '亿公顷' || unit == '亿元/平方米'){
      number = number / 100000000
    }
    number = ifFillZero ? number.toFixed(decimal) : parseFloat(number.toFixed(decimal))
    if(toString !== 'false'){
      var str = number.toString();
      var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      number = str.replace(reg,"$1,")
    }
    return { num:number, unit:unit };
  }
}

export function unitConvert(num,unit) {
  if(unit == '公顷'){
    var moneyUnits = ["公顷", "万公顷", "亿公顷", "万亿公顷"] 
  }else if(unit == '吨'){
    var moneyUnits = ["吨", "万吨", "亿吨", "万亿吨"]
  }else{
    var moneyUnits = ["元", "万元", "亿元", "万亿"]
  }
  var dividend = 10000;
  var curentNum = num ? num : 0;
  //转换数字 
  var curentUnit = moneyUnits[0];
  //转换单位 
  for (var i = 0; i <4; i++) { 
      curentUnit = moneyUnits[i] 
      if(strNumSize(curentNum)<5){ 
          break;
      }
      curentNum = curentNum / dividend 
  } 
  var m = {num: 0, unit: ""} 
  m.num = parseFloat(curentNum.toFixed(2)) 
  m.unit = curentUnit;
  if(m.num !=0){
      var str = m.num.toString();
      var reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      m.num = str.replace(reg,"$1,");
  }
  return m;
}

function strNumSize(tempNum){ 
  var stringNum = tempNum.toString() 
  var index = stringNum.indexOf(".") 
  var newNum = stringNum;
  if(index!=-1){
      newNum = stringNum.substring(0,index) 
  } 
  return newNum.length
}

/**
 * 不同参考系坐标的转换
 * @param {*} extent 要转换的坐标  可以是{xmin,ymin,xmax,ymax} 或者 [[lng,lat],...]
 * @param {String} fromProjection 转换前的坐标系 wkid
 * @param {*} toProjection 转换后的坐标系 wkid
 * @return {*} 转换后的坐标
 */
export function transformCrsCoordinate(extent,fromWkid,toWkid) {
  let fromProjection = null  // 转换前的坐标系说明
  let toProjection = null  // 转换后的坐标系说明
  let projection = wkid => {
    if(wkid == 4528){
      return '+proj=tmerc +lat_0=0 +lon_0=120 +k=1 +x_0=40500000 +y_0=0 +ellps=GRS80 +units=m +no_defs'
    }else if(wkid == 4326){
      return '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs'
    }else if(wkid == 4490){
      return '+proj=longlat +ellps=GRS80 +no_defs +type=crs'
    }else if(wkid == 3857){
      return '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs'
    }
  }
  fromProjection = projection(fromWkid)
  // toWkid不传就默认4326
  toProjection = toWkid ? projection(toWkid) : '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs'
  if(extent.xmin){
    let xyMinOld = [extent.xmin,extent.ymin]
    let xyMaxOld = [extent.xmax,extent.ymax]
    let xyMinNew = proj4(fromProjection, toProjection, xyMinOld);
    let xyMaxNew = proj4(fromProjection, toProjection, xyMaxOld);
    let extentNew = { 
      xmin:xyMinNew[0],
      xmax:xyMaxNew[0],
      ymin:xyMinNew[1],
      ymax:xyMaxNew[1] 
    }
    return extentNew
  }else{
    let lnglatArr = []
    extent.map(point => {
      let pointNew = proj4(fromProjection, toProjection, point);
      lnglatArr.push(pointNew)
    })
    return lnglatArr
  }
}

/**
 * 随机生成数字
 *
 * 示例：生成长度为 12 的随机数：randomNumber(12)
 * 示例：生成 3~23 之间的随机数：randomNumber(3, 23)
 *
 * @param1 最小值 | 长度
 * @param2 最大值
 * @return int 生成后的数字
 */
export function randomNumber() {
  // 生成 最小值 到 最大值 区间的随机数
  const random = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  if (arguments.length === 1) {
    let [length] = arguments
  // 生成指定长度的随机数字，首位一定不是 0
    let nums = [...Array(length).keys()].map((i) => (i > 0 ? random(0, 9) : random(1, 9)))
    return parseInt(nums.join(''))
  } else if (arguments.length >= 2) {
    let [min, max] = arguments
    return random(min, max)
  } else {
    return Number.NaN
  }
}

/**
 * 随机生成字符串
 * @param length 字符串的长度
 * @param chats 可选字符串区间（只会生成传入的字符串中的字符）
 * @return string 生成的字符串
 */
export function randomString(length, chats) {
  if (!length) length = 1
  if (!chats) chats = '0123456789qwertyuioplkjhgfdsazxcvbnm'
  let str = ''
  for (let i = 0; i < length; i++) {
    let num = randomNumber(0, chats.length - 1)
    str += chats[num]
  }
  return str
}

/**
 * 随机生成uuid
 * @return string 生成的uuid
 */
export function randomUUID() {
  let chats = '0123456789abcdef'
  return randomString(32, chats)
}

/**
 * 下划线转驼峰
 * @param string
 * @returns {*}
 */
export function underLine2CamelCase(string) {
  return string.replace(/_([a-z])/g, function(all, letter) {
    return letter.toUpperCase()
  })
}

/**
 * 判断是否显示办理按钮
 * @param bpmStatus
 * @returns {*}
 */
export function showDealBtn(bpmStatus) {
  if (bpmStatus !== '1' && bpmStatus !== '3' && bpmStatus !== '4') {
    return true
  }
  return false
}

/**
 * 增强CSS，可以在页面上输出全局css
 * @param css 要增强的css
 * @param id style标签的id，可以用来清除旧样式
 */
export function cssExpand(css, id) {
  let style = document.createElement('style')
  style.type = 'text/css'
  style.innerHTML = `@charset "UTF-8"; ${css}`
  // 清除旧样式
  if (id) {
    let $style = document.getElementById(id)
    if ($style != null) $style.outerHTML = ''
    style.id = id
  }
  // 应用新样式
  document.head.appendChild(style)
}

/** 用于js增强事件，运行JS代码，可以传参 */
// options 所需参数：
//    参数名         类型            说明
//    vm             VueComponent    vue实例
//    event          Object          event对象
//    jsCode         String          待执行的js代码
//    errorMessage   String          执行出错后的提示（控制台）
export function jsExpand(options = {}) {
  // 绑定到window上的keyName
  let windowKeyName = 'J_CLICK_EVENT_OPTIONS'
  if (typeof window[windowKeyName] !== 'object') {
    window[windowKeyName] = {}
  }

  // 随机生成JS增强的执行id，防止冲突
  let id = randomString(16, 'qwertyuioplkjhgfdsazxcvbnm'.toUpperCase())
  // 封装按钮点击事件
  let code = `
    (function (o_${id}) {
      try {
        (function (globalEvent, vm) {
          ${options.jsCode}
        })(o_${id}.event, o_${id}.vm)
      } catch (e) {
        o_${id}.error(e)
      }
      o_${id}.done()
    })(window['${windowKeyName}']['EVENT_${id}'])
  `
  // 创建script标签
  const script = document.createElement('script')
  // 将需要传递的参数挂载到window对象上
  window[windowKeyName]['EVENT_' + id] = {
    vm: options.vm,
    event: options.event,
    // 当执行完成时，无论如何都会调用的回调事件
    done() {
      // 执行完后删除新增的 script 标签不会撤销执行结果（已产生的结果不会被撤销）
      script.outerHTML = ''
      delete window[windowKeyName]['EVENT_' + id]
    },
    // 当js运行出错的时候调用的事件
    error(e) {
      console.group(`${options.errorMessage || '用户自定义JS增强代码运行出错'}（${new Date()}）`)
      console.error(e)
      console.groupEnd()
    }
  }
  // 将事件挂载到document中
  script.innerHTML = code
  document.body.appendChild(script)
}

/**
 * 如果值不存在就 push 进数组，反之不处理
 * @param array 要操作的数据
 * @param value 要添加的值
 * @param key 可空，如果比较的是对象，可能存在地址不一样但值实际上是一样的情况，可以传此字段判断对象中唯一的字段，例如 id。不传则直接比较实际值
 * @returns {boolean} 成功 push 返回 true，不处理返回 false
 */
export function pushIfNotExist(array, value, key) {
  for (let item of array) {
    if (key && (item[key] === value[key])) {
      return false
    } else if (item === value) {
      return false
    }
  }
  array.push(value)
  return true
}

/**
 * 可用于判断是否成功
 * @type {symbol}
 */
export const succeedSymbol = Symbol()
/**
 * 可用于判断是否失败
 * @type {symbol}
 */
export const failedSymbol = Symbol()

/**
 * 使 promise 无论如何都会 resolve，除非传入的参数不是一个Promise对象或返回Promise对象的方法
 * 一般用在 Promise.all 中
 *
 * @param promise 可传Promise对象或返回Promise对象的方法
 * @returns {Promise<any>}
 */
export function alwaysResolve(promise) {
  return new Promise((resolve, reject) => {
    let p = promise
    if (typeof promise === 'function') {
      p = promise()
    }
    if (p instanceof Promise) {
      p.then(data => {
        resolve({ type: succeedSymbol, data })
      }).catch(error => {
        resolve({ type: failedSymbol, error })
      })
    } else {
      reject('alwaysResolve: 传入的参数不是一个Promise对象或返回Promise对象的方法')
    }
  })
}

/**
 * 简单实现防抖方法
 *
 * 防抖(debounce)函数在第一次触发给定的函数时，不立即执行函数，而是给出一个期限值(delay)，比如100ms。
 * 如果100ms内再次执行函数，就重新开始计时，直到计时结束后再真正执行函数。
 * 这样做的好处是如果短时间内大量触发同一事件，只会执行一次函数。
 *
 * @param fn 要防抖的函数
 * @param delay 防抖的毫秒数
 * @returns {Function}
 */
export function simpleDebounce(fn, delay = 100) {
  let timer = null
  return function () {
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

/**
 * 不用正则的方式替换所有值
 * @param text 被替换的字符串
 * @param checker  替换前的内容
 * @param replacer 替换后的内容
 * @returns {String} 替换后的字符串
 */
export function replaceAll(text, checker, replacer) {
  let lastText = text
  text = text.replace(checker, replacer)
  if (lastText !== text) {
    return replaceAll(text, checker, replacer)
  }
  return text
}

/**
 * 获取事件冒泡路径，兼容 IE11，Edge，Chrome，Firefox，Safari
 * 目前使用的地方：JEditableTable Span模式
 */
export function getEventPath(event) {
  let target = event.target
  let path = (event.composedPath && event.composedPath()) || event.path

  if (path != null) {
    return (path.indexOf(window) < 0) ? path.concat(window) : path
  }

  if (target === window) {
    return [window]
  }

  let getParents = (node, memo) => {
    memo = memo || []
    const parentNode = node.parentNode

    if (!parentNode) {
      return memo
    } else {
      return getParents(parentNode, memo.concat(parentNode))
    }
  }
  return [target].concat(getParents(target), window)
}

/**
 * 根据组件名获取父级
 * @param vm
 * @param name
 * @returns {Vue | null|null|Vue}
 */
export function getVmParentByName(vm, name) {
  let parent = vm.$parent
  if (parent && parent.$options) {
    if (parent.$options.name === name) {
      return parent
    } else {
      let res = getVmParentByName(parent, name)
      if (res) {
        return res
      }
    }
  }
  return null
}

/**
 * 使一个值永远不会为（null | undefined）
 *
 * @param value 要处理的值
 * @param def 默认值，如果value为（null | undefined）则返回的默认值，可不传，默认为''
 */
export function neverNull(value, def) {
  return value == null ? (neverNull(def, '')) : value
}

/**
 * 根据元素值移除数组中的一个元素
 * @param array 数组
 * @param prod 属性名
 * @param value 属性值
 * @returns {string}
 */
export function removeArrayElement(array, prod, value) {
  let index = -1
  for (let i = 0; i < array.length; i++) {
    if (array[i][prod] === value) {
      index = i
      break
    }
  }
  if (index >= 0) {
    array.splice(index, 1)
  }
}

/** 判断是否是OAuth2APP环境 */
export function isOAuth2AppEnv() {
  return /wxwork|dingtalk/i.test(navigator.userAgent)
}

// 根据毫秒数转换为*天*小时*分*秒
export function getDurationByMillis (themillis) {
  if (!themillis) {
    return ''
  }
  let durationStr = ''
  let millis = Math.abs(themillis)
  const days = parseInt(millis / (1000 * 60 * 60 * 24))
  const hours = parseInt((millis % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  const minutes = parseInt((millis % (1000 * 60 * 60)) / (1000 * 60))
  const seconds = Math.ceil((millis % (1000 * 60)) / 1000)
  durationStr += durationStr || days ? days + '天' : ''
  durationStr += durationStr || hours ? hours + '小时' : ''
  durationStr += durationStr || minutes ? minutes + '分' : ''
  durationStr += durationStr || seconds ? seconds + '秒' : '0秒'
  return (themillis < 0 ? '超时' : '') + durationStr
}

// 江苏省十三个市数据
export function getCityData () {
  return [
    {
      name:'南京市',
      code:'320100'
    },
    {
      name:'无锡市',
      code:'320200'
    },
    {
      name:'徐州市',
      code:'320300'
    },
    {
      name:'常州市',
      code:'320400'
    },
    {
      name:'苏州市',
      code:'320500'
    },
    {
      name:'南通市',
      code:'320600'
    },
    {
      name:'连云港市',
      code:'320700'
    },
    {
      name:'淮安市',
      code:'320800'
    },
    {
      name:'盐城市',
      code:'320900'
    },
    {
      name:'扬州市',
      code:'321000'
    },
    {
      name:'镇江市',
      code:'321100'
    },
    {
      name:'泰州市',
      code:'321200'
    },
    {
      name:'宿迁市',
      code:'321300'
    }
  ]
}

// 江苏省十三个市下面的区、县级数据
export function getAreaData () {
  return [
    // 南京市
    {
      name:'玄武区',
      code:'320102'
    },
    {
      name:'秦淮区',
      code:'320104'
    },
    {
      name:'建邺区',
      code:'320105'
    },
    {
      name:'鼓楼区',
      code:'320106'
    },
    {
      name:'浦口区',
      code:'320111'
    },
    {
      name:'栖霞区',
      code:'320113'
    },
    {
      name:'雨花台区',
      code:'320114'
    },
    {
      name:'江宁区',
      code:'320115'
    },
    {
      name:'六合区',
      code:'320116'
    },
    {
      name:'溧水区',
      code:'320117'
    },
    {
      name:'高淳区',
      code:'320118'
    },
    // 无锡市
    {
      name:'锡山区',
      code:'320205'
    },
    {
      name:'惠山区',
      code:'320206'
    },
    {
      name:'滨湖区',
      code:'320211'
    },
    {
      name:'梁溪区',
      code:'320213'
    },
    {
      name:'新吴区',
      code:'320214'
    },
    {
      name:'江阴市',
      code:'320281'
    },
    {
      name:'宜兴市',
      code:'320282'
    },
    // 徐州市
    {
      name:'鼓楼区',
      code:'320302'
    },
    {
      name:'云龙区',
      code:'320303'
    },
    {
      name:'贾汪区',
      code:'320305'
    },
    {
      name:'泉山区',
      code:'320311'
    },
    {
      name:'铜山区',
      code:'320312'
    },
    {
      name:'丰县',
      code:'320321'
    },
    {
      name:'沛县',
      code:'320322'
    },
    {
      name:'睢宁县',
      code:'320324'
    },
    {
      name:'新沂市',
      code:'320381'
    },
    {
      name:'邳州市',
      code:'320382'
    },
    // 常州市
    {
      name:'天宁区',
      code:'320402'
    }, 
    {
      name:'钟楼区',
      code:'320404'
    }, 
    {
      name:'新北区',
      code:'320411'
    }, 
    {
      name:'武进区',
      code:'320412'
    }, 
    {
      name:'金坛区',
      code:'320413'
    }, 
    {
      name:'溧阳市',
      code:'320481'
    },
    // 苏州市
    {
      name:'虎丘区',
      code:'320505'
    },
    {
      name:'吴中区',
      code:'320506'
    },
    {
      name:'相城区',
      code:'320507'
    },
    {
      name:'姑苏区',
      code:'320508'
    },
    {
      name:'吴江区',
      code:'320509'
    },
    {
      name:'常熟市',
      code:'320581'
    },
    {
      name:'张家港市',
      code:'320582'
    },
    {
      name:'昆山市',
      code:'320583'
    },
    {
      name:'太仓市',
      code:'320585'
    },
    // 南通市
    {
      name:'崇川区',
      code:'320602'
    },
    {
      name:'通州区',
      code:'320612'
    },
    {
      name:'如东县',
      code:'320623'
    },
    {
      name:'启东市',
      code:'320681'
    },
    {
      name:'如皋市',
      code:'320682'
    },
    {
      name:'海门区',
      code:'320684'
    },
    {
      name:'海安市',
      code:'320685'
    },
    // 连云港市
    {
      name:'连云区',
      code:'320703'
    },
    {
      name:'海州区',
      code:'320706'
    }, 
    {
      name:'赣榆区',
      code:'320707'
    },
    {
      name:'东海县',
      code:'320722'
    },
    {
      name:'灌云县',
      code:'320723'
    }, 
    {
      name:'灌南县',
      code:'320724'
    },
    // 淮安市
    {
      name:'淮安区',
      code:'320803'
    },
    {
      name:'淮阴区',
      code:'320804'
    },
    {
      name:'清江浦区',
      code:'320812'
    },
    {
      name:'洪泽区',
      code:'320813'
    },
    {
      name:'涟水县',
      code:'320826'
    },
    {
      name:'盱眙县',
      code:'320830'
    },
    {
      name:'金湖县',
      code:'320831'
    },
    // 盐城市
    {
      name:'亭湖区',
      code:'320902'
    },
    {
      name:'盐都区',
      code:'320903'
    },
    {
      name:'大丰区',
      code:'320904'
    },
    {
      name:'响水县',
      code:'320921'
    },
    {
      name:'滨海县',
      code:'320922'
    },
    {
      name:'阜宁县',
      code:'320923'
    },
    {
      name:'射阳县',
      code:'320924'
    },
    {
      name:'建湖县',
      code:'320925'
    },
    {
      name:'东台市',
      code:'320981'
    },
    // 扬州市
    {
      name:'广陵区',
      code:'321002'
    },
    {
      name:'邗江区',
      code:'321003'
    },
    {
      name:'江都区',
      code:'321012'
    },
    {
      name:'宝应县',
      code:'321023'
    },
    {
      name:'仪征市',
      code:'321081'
    },
    {
      name:'高邮市',
      code:'321084'
    },
    // 镇江市
    {
      name:'京口区',
      code:'321102'
    },
    {
      name:'润州区',
      code:'321111'
    },
    {
      name:'丹徒区',
      code:'321112'
    },
    {
      name:'丹阳市',
      code:'321181'
    },
    {
      name:'扬中市',
      code:'321182'
    },
    {
      name:'句容市',
      code:'321183'
    },
    // 泰州市
    {
      name:'海陵区',
      code:'321202'
    },
    {
      name:'高港区',
      code:'321203'
    },
    {
      name:'姜堰区',
      code:'321204'
    },
    {
      name:'兴化市',
      code:'321281'
    },
    {
      name:'靖江市',
      code:'321282'
    },
    {
      name:'泰兴市',
      code:'321283'
    },
    // 宿迁市
    {
      name:'宿城区',
      code:'321302'
    },
    {
      name:'宿豫区',
      code:'321311'
    },
    {
      name:'沭阳县',
      code:'321322'
    },
    {
      name:'泗阳县',
      code:'321323'
    },
    {
      name:'泗洪县',
      code:'321324'
    }
  ]
}

// 江苏省市、区、县总数据
export function getCityAreaData () {
  return [
    {
      name:'南京市',
      code:'320100'
    },
    {
      name:'无锡市',
      code:'320200'
    },
    {
      name:'徐州市',
      code:'320300'
    },
    {
      name:'常州市',
      code:'320400'
    },
    {
      name:'苏州市',
      code:'320500'
    },
    {
      name:'南通市',
      code:'320600'
    },
    {
      name:'连云港市',
      code:'320700'
    },
    {
      name:'淮安市',
      code:'320800'
    },
    {
      name:'盐城市',
      code:'320900'
    },
    {
      name:'扬州市',
      code:'321000'
    },
    {
      name:'镇江市',
      code:'321100'
    },
    {
      name:'泰州市',
      code:'321200'
    },
    {
      name:'宿迁市',
      code:'321300'
    },
    // 南京市
    {
      name:'玄武区',
      code:'320102'
    },
    {
      name:'秦淮区',
      code:'320104'
    },
    {
      name:'建邺区',
      code:'320105'
    },
    {
      name:'鼓楼区',
      code:'320106'
    },
    {
      name:'浦口区',
      code:'320111'
    },
    {
      name:'栖霞区',
      code:'320113'
    },
    {
      name:'雨花台区',
      code:'320114'
    },
    {
      name:'江宁区',
      code:'320115'
    },
    {
      name:'六合区',
      code:'320116'
    },
    {
      name:'溧水区',
      code:'320117'
    },
    {
      name:'高淳区',
      code:'320118'
    },
    // 无锡市
    {
      name:'锡山区',
      code:'320205'
    },
    {
      name:'惠山区',
      code:'320206'
    },
    {
      name:'滨湖区',
      code:'320211'
    },
    {
      name:'梁溪区',
      code:'320213'
    },
    {
      name:'新吴区',
      code:'320214'
    },
    {
      name:'江阴市',
      code:'320281'
    },
    {
      name:'宜兴市',
      code:'320282'
    },
    // 徐州市
    {
      name:'鼓楼区',
      code:'320302'
    },
    {
      name:'云龙区',
      code:'320303'
    },
    {
      name:'贾汪区',
      code:'320305'
    },
    {
      name:'泉山区',
      code:'320311'
    },
    {
      name:'铜山区',
      code:'320312'
    },
    {
      name:'丰县',
      code:'320321'
    },
    {
      name:'沛县',
      code:'320322'
    },
    {
      name:'睢宁县',
      code:'320324'
    },
    {
      name:'新沂市',
      code:'320381'
    },
    {
      name:'邳州市',
      code:'320382'
    },
    // 常州市
    {
      name:'天宁区',
      code:'320402'
    }, 
    {
      name:'钟楼区',
      code:'320404'
    }, 
    {
      name:'新北区',
      code:'320411'
    }, 
    {
      name:'武进区',
      code:'320412'
    }, 
    {
      name:'金坛区',
      code:'320413'
    }, 
    {
      name:'溧阳市',
      code:'320481'
    },
    // 苏州市
    {
      name:'虎丘区',
      code:'320505'
    },
    {
      name:'吴中区',
      code:'320506'
    },
    {
      name:'相城区',
      code:'320507'
    },
    {
      name:'姑苏区',
      code:'320508'
    },
    {
      name:'吴江区',
      code:'320509'
    },
    {
      name:'常熟市',
      code:'320581'
    },
    {
      name:'张家港市',
      code:'320582'
    },
    {
      name:'昆山市',
      code:'320583'
    },
    {
      name:'太仓市',
      code:'320585'
    },
    // 南通市
    {
      name:'崇川区',
      code:'320602'
    },
    {
      name:'通州区',
      code:'320612'
    },
    {
      name:'如东县',
      code:'320623'
    },
    {
      name:'启东市',
      code:'320681'
    },
    {
      name:'如皋市',
      code:'320682'
    },
    {
      name:'海门区',
      code:'320684'
    },
    {
      name:'海安市',
      code:'320685'
    },
    // 连云港市
    {
      name:'连云区',
      code:'320703'
    },
    {
      name:'海州区',
      code:'320706'
    }, 
    {
      name:'赣榆区',
      code:'320707'
    },
    {
      name:'东海县',
      code:'320722'
    },
    {
      name:'灌云县',
      code:'320723'
    }, 
    {
      name:'灌南县',
      code:'320724'
    },
    // 淮安市
    {
      name:'淮安区',
      code:'320803'
    },
    {
      name:'淮阴区',
      code:'320804'
    },
    {
      name:'清江浦区',
      code:'320812'
    },
    {
      name:'洪泽区',
      code:'320813'
    },
    {
      name:'涟水县',
      code:'320826'
    },
    {
      name:'盱眙县',
      code:'320830'
    },
    {
      name:'金湖县',
      code:'320831'
    },
    // 盐城市
    {
      name:'亭湖区',
      code:'320902'
    },
    {
      name:'盐都区',
      code:'320903'
    },
    {
      name:'大丰区',
      code:'320904'
    },
    {
      name:'响水县',
      code:'320921'
    },
    {
      name:'滨海县',
      code:'320922'
    },
    {
      name:'阜宁县',
      code:'320923'
    },
    {
      name:'射阳县',
      code:'320924'
    },
    {
      name:'建湖县',
      code:'320925'
    },
    {
      name:'东台市',
      code:'320981'
    },
    // 扬州市
    {
      name:'广陵区',
      code:'321002'
    },
    {
      name:'邗江区',
      code:'321003'
    },
    {
      name:'江都区',
      code:'321012'
    },
    {
      name:'宝应县',
      code:'321023'
    },
    {
      name:'仪征市',
      code:'321081'
    },
    {
      name:'高邮市',
      code:'321084'
    },
    // 镇江市
    {
      name:'京口区',
      code:'321102'
    },
    {
      name:'润州区',
      code:'321111'
    },
    {
      name:'丹徒区',
      code:'321112'
    },
    {
      name:'丹阳市',
      code:'321181'
    },
    {
      name:'扬中市',
      code:'321182'
    },
    {
      name:'句容市',
      code:'321183'
    },
    // 泰州市
    {
      name:'海陵区',
      code:'321202'
    },
    {
      name:'高港区',
      code:'321203'
    },
    {
      name:'姜堰区',
      code:'321204'
    },
    {
      name:'兴化市',
      code:'321281'
    },
    {
      name:'靖江市',
      code:'321282'
    },
    {
      name:'泰兴市',
      code:'321283'
    },
    // 宿迁市
    {
      name:'宿城区',
      code:'321302'
    },
    {
      name:'宿豫区',
      code:'321311'
    },
    {
      name:'沭阳县',
      code:'321322'
    },
    {
      name:'泗阳县',
      code:'321323'
    },
    {
      name:'泗洪县',
      code:'321324'
    }
  ]
}